import { http } from "../../utils/config";

/**
 * Chương trình tích điểm + lịch sử tích điểm.
 *
 * Hàm async thuần (đã bỏ `createAsyncThunk` cùng 3 slice `pointPromotion`,
 * `pointPromotionForCusActive`, `pointPromotionHistories`).
 *
 * Query dựng bằng `params` của axios thay vì nối chuỗi tay — bản cũ không encode
 * nên từ khóa tìm kiếm chứa `&`/`#`/khoảng trắng là cắt mất phần sau.
 * Lỗi để nguyên cho nơi gọi bóc bằng `errorMessage()`.
 */

const BASE = "/api/v1/serviceconnect/point-promotion";
const FOR_CUSTOMER = "/api/v1/serviceconnect/point-promotion-for-customer";

/** Bỏ field rỗng: BE coi thiếu tham số là "không lọc theo tiêu chí này". */
function compact(obj) {
  const out = {};
  for (const [k, v] of Object.entries(obj)) {
    if (v === undefined || v === null || v === "") continue;
    out[k] = v;
  }
  return out;
}

/**
 * Chuẩn hóa bộ lọc theo ID: `0` trong CMS này nghĩa là "tất cả", không phải id 0.
 *
 * Bắt buộc phải có. Bản cũ nối chuỗi bằng `if (mcouponBranchId)` nên `0` tự rơi;
 * `compact()` chỉ bỏ `undefined/null/""` nên `0` lọt xuống BE và bị lọc theo chi
 * nhánh id=0 -> danh sách rỗng. `ScanPointOrder` khởi tạo `branchIdSearch: 0` nên
 * dính ngay từ lần tải đầu.
 */
const idFilter = (v) => (v === 0 || v === "0" ? undefined : v);

/** `[from, to]` -> `{ start_date, end_date }`; rỗng thì bỏ hẳn. */
function dateRange(selectedDates) {
  if (!selectedDates || selectedDates.length < 2) return {};
  return { start_date: selectedDates[0], end_date: selectedDates[1] };
}

/* ----------------------------- Chương trình ------------------------------- */

export const getListPointPromotion = (
  { currentPage = 1, pageSize = 10, mcouponBranchId, status, selectedDates, type } = {},
  signal
) =>
  http
    .get(BASE, {
      signal,
      params: compact({
        has_paginate: 1,
        size: pageSize,
        page: currentPage,
        mcoupon_branch_id: idFilter(mcouponBranchId),
        status,
        type,
        ...dateRange(selectedDates),
      }),
    })
    .then((res) => res.data);

export const getByIdPointPromotion = ({ id }, signal) =>
  http.get(`${BASE}/${id}`, { signal }).then((res) => res.data);

export const createPointPromotion = (data) =>
  http.post(BASE, data).then((res) => res.data);

export const updatePointPromotion = ({ id, data }) =>
  http.put(`${BASE}/${id}`, data).then((res) => res.data);

export const deletePointPromotion = (id) =>
  http.delete(`${BASE}/${id}`).then((res) => res.data);

export const statusPointPromotion = ({ id, data }) =>
  http.put(`${BASE}/status/${id}`, data).then((res) => res.data);

export const addProductsToPromotionAPI = (data) =>
  http.post(`${BASE}/add-products-to-promotion`, data).then((res) => res.data);

export const updateProductCoefficientAPI = ({ id, data }) =>
  http.put(`${BASE}/items/${id}`, data).then((res) => res.data);

/* ------------------------- Chương trình cho khách -------------------------- */

export const getListPointPromotionForCustomerActive = (
  { currentPagex = 1, pageSizex = 10 } = {},
  signal
) =>
  http
    .get(`${FOR_CUSTOMER}/active`, {
      signal,
      params: { has_paginate: 1, size: pageSizex, page: currentPagex },
    })
    .then((res) => res.data);

export const getListPointPromotionForCustomerActiveV2 = (
  { orderNo, currentPagex = 1, pageSizex = 10 } = {},
  signal
) =>
  http
    .get(`${FOR_CUSTOMER}/with-order/${orderNo}`, {
      signal,
      params: { has_paginate: 1, size: pageSizex, page: currentPagex },
    })
    .then((res) => res.data);

export const scanPointOrder = (data) =>
  http.post(`${FOR_CUSTOMER}/scan-point-order`, data).then((res) => res.data);

/* ------------------------------ Lịch sử phiếu ------------------------------ */

export const getListPointPromotionHistories = (
  {
    currentPage = 1,
    pageSize = 10,
    mcouponBranchId,
    selectedDates,
    keySearch,
    phoneSearch,
    promotionId,
    status,
    source,
  } = {},
  signal
) =>
  http
    .get(`${FOR_CUSTOMER}/cms/histories`, {
      signal,
      params: compact({
        has_paginate: 1,
        size: pageSize,
        page: currentPage,
        mcoupon_branch_id: idFilter(mcouponBranchId),
        keySearch,
        phoneSearch,
        promotionId: idFilter(promotionId),
        // BE nhận tên `order_status` cho bộ lọc trạng thái duyệt đơn.
        order_status: status,
        source,
        ...dateRange(selectedDates),
      }),
    })
    .then((res) => res.data);

/**
 * Chi tiết một phiếu.
 *
 * Kèm `scanned_product_code` (mã đã quét + lô/sản phẩm/hạn dùng/người tạo) khi
 * phiếu có `source = MINIAPP_SCAN`; các nguồn khác trường này là null.
 */
export const getPointPromotionHistoryDetail = (id, signal) =>
  http.get(`${FOR_CUSTOMER}/cms/histories/${id}/detail`, { signal }).then((res) => res.data);
